import { DoqFaceSvgProps } from '../types';

const Simple = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1698_47945)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-simple">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#8800FF"
        mask="url(#bottom-mask-simple)"
      />

      <mask
        id="mask0_1698_47945"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_47945)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M96 243C96 242.448 96.4477 242 97 242H223C223.552 242 224 242.448 224 243V245C224 245.552 223.552 246 223 246H97C96.4477 246 96 245.552 96 245V243Z"
          fill="#2974C4"
        />
        <path
          d="M96 277C96 276.448 96.4477 276 97 276H223C223.552 276 224 276.448 224 277V279C224 279.552 223.552 280 223 280H97C96.4477 280 96 279.552 96 279V277Z"
          fill="#2974C4"
        />
        <path
          d="M97 258C96.4477 258 96 258.448 96 259V261C96 261.552 96.4477 262 97 262H223C223.552 262 224 261.552 224 261V259C224 258.448 223.552 258 223 258H97Z"
          fill="#2974C4"
        />
        <path
          d="M96 293C96 292.448 96.4477 292 97 292H223C223.552 292 224 292.448 224 293V295C224 295.552 223.552 296 223 296H97C96.4477 296 96 295.552 96 295V293Z"
          fill="#2974C4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 208C153.078 208 147.907 204.783 145.141 200L150.056 200C152.253 202.455 155.446 204 159 204C162.554 204 165.747 202.455 167.944 200L172.859 200C170.093 204.783 164.922 208 159 208Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.969 177C154.453 185.371 147.501 192 139 192C130.163 192 123 184.837 123 176C123 167.163 130.163 160 139 160C147.159 160 153.892 166.107 154.876 174H165.124C166.108 166.107 172.841 160 181 160C189.837 160 197 167.163 197 176C197 184.837 189.837 192 181 192C172.499 192 165.547 185.371 165.031 177H154.969ZM152 176C152 183.18 146.18 189 139 189C131.82 189 126 183.18 126 176C126 168.82 131.82 163 139 163C146.18 163 152 168.82 152 176ZM181 189C188.18 189 194 183.18 194 176C194 168.82 188.18 163 181 163C173.82 163 168 168.82 168 176C168 183.18 173.82 189 181 189Z"
        fill="#2974C4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1698_47945">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { Simple };
